import React from 'react'
import { Box } from '@mui/material'
import { MedGEOLogoComponent } from 'assets/MedGEOlogo'

const LogoHeader: React.FC = () => {
  return (
    <Box textAlign="center" mb={4}>
      <MedGEOLogoComponent />
    </Box>
  )
}

export default LogoHeader
